import type { IconType } from "react-icons";
import { Link, useLocation } from "react-router-dom";

import {
  SidebarGroup,
  SidebarMenu,
  SidebarMenuBadge,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@ospra/design-system/components/sidebar";

export function NavItems({
  items,
  itemButtonClassName,
  ...props
}: {
  items: {
    name: string;
    url: string;
    icon: IconType;
    badge?: string;
    activeSegment?: string;
  }[];
  itemButtonClassName?: string;
} & React.ComponentPropsWithoutRef<typeof SidebarGroup>) {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <SidebarGroup {...props}>
      <SidebarMenu>
        {items.map((item) => {
          const isActive =
            item.url === "/"
              ? currentPath === "/" || currentPath === "/overview"
              : currentPath.startsWith(item.url);

          return (
            <SidebarMenuItem key={item.name}>
              <SidebarMenuButton
                className={itemButtonClassName}
                isActive={isActive}
                nativeButton={false}
                render={
                  <Link to={item.url}>
                    <item.icon />
                    <span>{item.name}</span>
                  </Link>
                }
              />
              {item.badge && (
                <SidebarMenuBadge className="top-2! opacity-50">
                  {item.badge}
                </SidebarMenuBadge>
              )}
            </SidebarMenuItem>
          );
        })}
      </SidebarMenu>
    </SidebarGroup>
  );
}
